import axios from "axios";
import React from "react";
import config from '../../config';
import { headers } from "../../token";
import Swal from "sweetalert2";
import validateError from "../../ValidateError";

const DeleteGroup = (GroupID, username, getGroups) => {
    const server_backend = config.API_URL;

    Swal.fire({
        icon: 'warning',
        title: 'Alert',
        text: "Are you sure you want to delete the Group? This action cannot be undone.",
        showCancelButton: true,
        confirmButtonText: 'Accept',
        cancelButtonText: "Cancel"
    }).then(async (result) => {
        if (result.isConfirmed) {
            try {
                const response = await axios.post(`${server_backend}/groups/delete`, {
                    id: GroupID,
                    user_transaction: username
                }, headers);
              
                if (response.data.RES_CODE === "00") {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: "Success.",
                        showConfirmButton: false,
                        timer: 1000
                    }).then(async () => {
                        getGroups()
                    });
                } else if (response.data.StatusCode === 200) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: response.data.StatusMessage,
                        showConfirmButton: false,
                        timer: 1000
                    });
                }

            } catch (error) {
                const message = validateError(error);

                Swal.fire({
                    icon: 'error',
                    title: message,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        }
    });

};
export default DeleteGroup;